import * as ents from '@attain-apps/entities'

import type * as models from './models'

export interface State {
  /** Represents users available for assignment */
  users: readonly models.User[]
  selectedUserIds: readonly ents.core.admin.User.Id[]
  selectedAgentIds: readonly ents.core.agent.Agent.Id[]
  isEditing: boolean
  access: ents.core.admin.Access
  markedUserForUnassignment?: models.User
  markedAgentIdForUnassignment?: ents.core.agent.Agent.Id
  error?: Error
  mutationError?: Error
  pageAliases?: Set<string>
  isForNonPrebuiltPages?: boolean
}
export namespace State {
  export const INITIAL: Readonly<State> = {
    access: ents.core.admin.Access.Flag.CanUse,
    error: undefined,
    isEditing: false,
    isForNonPrebuiltPages: undefined,
    markedAgentIdForUnassignment: undefined,
    markedUserForUnassignment: undefined,
    mutationError: undefined,
    pageAliases: undefined,
    selectedAgentIds: [],
    selectedUserIds: [],
    users: [],
  }

  /**
   * Reset state to initial values
   */
  export function setInitial(): State {
    return INITIAL
  }

  /**
   * Reset editing state to initial values
   */
  export function reset(state: State): State {
    return {
      ...state,
      access: ents.core.admin.Access.Flag.CanUse,
      isEditing: false,
      isForNonPrebuiltPages: undefined,
      markedAgentIdForUnassignment: undefined,
      markedUserForUnassignment: undefined,
      mutationError: undefined,
      pageAliases: undefined,
      selectedAgentIds: [],
      selectedUserIds: [],
    }
  }
}
